module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"review_detail_title":"리뷰 자세히 보기"}}')
  delete Component.options._Ctor
}
